import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {ArrowRightIcon} from "@mui/x-date-pickers";

// Components
import MobileItem from "components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import Badge from "components/Badge";

// Context
import {MissionContext} from "../context/MissionContext";

// Helpers
import {getTranslation} from "domain/helpers/translations";

RetailerList.propTypes = {
    onClickRetailerLine: PropTypes.func,
    retailers: PropTypes.arrayOf(PropTypes.object).isRequired,
    filterValue: PropTypes.number.isRequired,
};

function RetailerList({onClickRetailerLine = (retailer) => {}, retailers, filterValue}) {
    const {
        getPickingTotal,
        getInTrolleyTotal,
        getCancelledTotal,
        getWmsItemsByRetailer,
    } = React.useContext(MissionContext);

    function getBadgeColor(retailerItemsInTrolleyTotal, totalRetailerItems) {
        if (retailerItemsInTrolleyTotal > 0 && retailerItemsInTrolleyTotal < totalRetailerItems) {
            return 'warning';
        } else if (retailerItemsInTrolleyTotal === totalRetailerItems) {
            return 'online';
        }

        return 'info';
    }

    return (
        <div
            style={{
                fontSize: '16px',
                fontWeight: 600,
            }}
        >
            {retailers?.map(retailer => {
                const items =  getWmsItemsByRetailer(retailer);
                const totalRetailerItems = items.length;

                let totalFilteredItems = 0;

                const retailerItemsToPickTotal = getPickingTotal(items);
                const retailerItemsInTrolleyTotal = getInTrolleyTotal(items) + getCancelledTotal(items);

                if (filterValue === 0) {
                    totalFilteredItems = retailerItemsToPickTotal;
                } else if (filterValue === 1) {
                    totalFilteredItems = retailerItemsInTrolleyTotal;
                }

                if (totalFilteredItems === 0) {
                    return null;
                }

                return (
                    <MobileItem
                        onClick={() => onClickRetailerLine(retailer)}
                        key={retailer.id}
                    >
                        <MobileItem.LeftSide
                            title={retailer.name}
                            subtitle={(
                                <>
                                    {totalFilteredItems} <FormattedMessage id={"wms.myPickingMission.articles"}/>
                                </>
                            )}
                        >
                            <ThumbnailAndNotification
                                link={getTranslation(retailer)?.logo?.contentUrl || ""}
                                validated={retailerItemsInTrolleyTotal > 0 && retailerItemsInTrolleyTotal === totalRetailerItems}
                            />
                        </MobileItem.LeftSide>
                        <MobileItem.RightSide>
                            <div style={{display: 'flex'}}>
                                <div style={{ marginRight: '8px' }}>
                                    <Badge
                                        rounded={true}
                                        isBold={false}
                                        color={getBadgeColor(retailerItemsInTrolleyTotal, totalRetailerItems)}
                                        size={'large'}
                                    >
                                        {retailerItemsInTrolleyTotal}/{totalRetailerItems}
                                    </Badge>
                                </div>
                                <ArrowRightIcon />
                            </div>
                        </MobileItem.RightSide>
                    </MobileItem>
                )
            })}
        </div>
    )
}

export default RetailerList;
